// extracted by mini-css-extract-plugin
module.exports = {"primaryOrangeSm":"_1gKA2G3l"};